import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './Style/Profile.css';
import useUsersData from './AllUsers';
import TopNavbar from '../home/TopNavbar';
import UsePayments from '../Backend/UsePayments';
import UsePaymentItems from '../Backend/UsePaymentItems';

const toIST = (dateString) => {
    if (!dateString) return 'Loading...';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

const getAvatarColor = (name) => {
    if (!name || name === "Loading") return '#3b82f6';
    const colors = [
        '#e53e3e', '#dd6b20', '#d69e2e', '#38a169',
        '#319795', '#3182ce', '#5a67d8', '#805ad5',
        '#d53f8c', '#00bcd4', '#ed8936', '#48bb78'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

const AccountAccess = () => {
    const { userPhone } = useParams();
    const { users, loading: usersLoading } = useUsersData();
    
    // Hooks for payments
    const { allPayments = [], paymentLoading } = UsePayments();
    const { paymentItems = [] } = UsePaymentItems();
    
    const [isPayment, setIsPayment] = useState(false);

    // User details mapping
    const targetUser = users.find(user => user.phone === userPhone);
    const userName = targetUser?.name || "Loading";
    const userEmail = targetUser?.email || "Loading";
    const userClass = targetUser?.class || "Loading";
    const registerDate = targetUser?.registar_date || "Loading";
    const lastLogin = targetUser?.last_login || "Loading";

    // Update payment status state safely
    useEffect(() => {
        const hasPayment = allPayments.some(payment => payment.phone === userPhone);
        setIsPayment(hasPayment);
    }, [allPayments, userPhone]);

    // Payment & Item details mapping (with safe fallbacks)
    const targetPayment = allPayments.find(payment => payment.phone === userPhone);
    const buyItem = targetPayment?.buyed;
    const itemPrice = targetPayment?.amount;
    
    const targetPaymentItem = paymentItems.find(paymentItem => paymentItem.itemId == buyItem);
    const itemName = targetPaymentItem?.name;
    const itemAbout = targetPaymentItem?.about;
    const itemValid = targetPaymentItem?.valid;

    const firstLetter = userName !== "Loading" ? userName.charAt(0).toUpperCase() : '?';
    const avatarColor = getAvatarColor(userName);

    return (
        <div className="profile-page-container">
            <div className="profile-content-wrapper">
                <TopNavbar name="Profile" />
                <div className="profile-card">

                    {/* Header with gradient + overlapping avatar */}
                    <div className="profile-header">
                        <div
                            className="profile-avatar"
                            style={{
                                backgroundColor: avatarColor,
                                color: '#fff',
                                fontWeight: '700'
                            }}
                        >
                            {firstLetter}
                        </div>
                        <h2>{userName}</h2>
                    </div>

                    <div className="profile-details">
                        <div className="detail-item">
                            <span className="detail-label">Name:</span>
                            <span className="detail-value">{userName}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Class</span>
                            <span className="detail-value">{userClass}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Phone</span>
                            <span className="detail-value">{userPhone}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Email ID</span>
                            <span className="detail-value">{userEmail}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Register Date</span>
                            <span className="detail-value">{toIST(registerDate)}</span>
                        </div>
                        <div className="detail-item">
                            <span className="detail-label">Last Login</span>
                            <span className="detail-value">{toIST(lastLogin)}</span>
                        </div>
                    </div>

                    {isPayment && (
                        <div className="profile-details">
                            <p style={{ textAlign: "center", padding: "10px" }}>Purchase details</p>
                            <hr />
                            <div className="detail-item">
                                <span className="detail-label">Item Name:</span>
                                <span className="detail-value">{itemName || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Validity:</span>
                                <span className="detail-value">{itemValid || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Price:</span>
                                <span className="detail-value">{itemPrice || 'Loading...'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Details:</span>
                                <span className="detail-value">{itemAbout || 'Loading...'}</span>
                            </div>
                        </div>
                    )}

                    <div className="profile-actions-container">
                        <Link to="/update-profile" className="btn-profile btn-update">
                            Update Profile
                        </Link>
                        <Link to="/logout" className="btn-profile btn-logout">
                            Logout
                        </Link>
                    </div>

                    <div className="profile-actions-container">
                        <Link to="/account-delete" className="btn-profile btn-warning">
                            Delete Account
                        </Link>
                    </div>
                    <br /><br /><br /><br />
                </div>
            </div>
        </div>
    );
};

export default AccountAccess;